export interface ParametresState {
    lastSync: string,
    mobiVersion: string,
    localPointagesfalse: number,
    remotePointagesfalse: number,
    localSupplementsfalse: number,
    remoteSupplementsfalse: number,
    localPointagesfalseOthers: number,
    remotePointagesTrueOthers: number,
    remotePointagesfalseOthers: number,
    localSupplementsfalseOthers: number,
    remoteSupplementsTrueOthers: number,
    remoteSupplementsfalseOthers: number,
    upgrade:string
}
export enum PRAMATRES_STORE {
    SET_LAST_SYNC = "SET_LAST_SYNC",
    SET_MOBI_VERSION = "SET_MOBI_VERSION",
    SET_LOCAL_POINTAGE_FALSE = "SET_LOCAL_POINTAGE_FALSE",
    SET_REMOTE_POINTAGE_FALSE = "SET_REMOTE_POINTAGE_FALSE",
    SET_LOCAL_SUPPLEMENTS_FALSE = "SET_LOCAL_SUPPLEMENTS_FALSE",
    SET_REMOTE_SUPPLEMENTS_FALSE = "SET_REMOTE_SUPPLEMENTS_FALSE",
    SET_LOCAL_POINTAGE_FALSE_OTHERS = "SET_LOCAL_POINTAGE_FALSE_OTHERS",
    SET_REMOTE_POINTAGE_FALSE_OTHERS = "SET_REMOTE_POINTAGE_FALSE_OTHERS",
    SET_REMOTE_POINTAGE_TRUE_OTHERS = "SET_REMOTE_POINTAGE_TRUE_OTHERS",
    SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS = "SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS",
    SET_REMOTE_SUPPLEMENTS_FALSE_OTHERS = "SET_REMOTE_SUPPLEMENTS_FALSE_OTHERS",
    SET_REMOTE_SUPPLEMENTS_TRUE_OTHERS = "SET_REMOTE_SUPPLEMENTS_TRUE_OTHERS",
    SET_UPGRADE = "SET_UPGRADE",
}
